import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { useTranslations } from "next-intl";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Navigation } from "swiper";
import PrevArrow from "../../../assets/PrevArrow";
import NextArrow from "../../../assets/NextArrow";
import Image from "next/image";
import Section_name from "../../../ipillion/Section_name";
import Flutter from "../../../../public/ipillion/Flutter";
import Next from "../../../../public/ipillion/Next";
import Css from "../../../../public/ipillion/Css";
import Html from "../../../../public/ipillion/Html";

import Sql from "../icons/Sql";
import Python from "../icons/Python";
import Node from "../../../../public/ipillion/Node";
import Mongo from "../../../../public/ipillion/Mongo";
import Postgres from "../../../../public/ipillion/Postgres";
export default function TechSlider() {
  const router = useRouter();
  const lang = router.locale;
  const [arrow, setArrow] = useState({ isEnd: false, isBeginning: true });
  const t = useTranslations("ez_credit.TechSlider");

  let next = null;

  return (
    <div className="relative mb-5">
      <div className=" max-w-[90rem] responsive m-auto">
        <Section_name
          name={t("title")}
          color={"#C29D3E"}
          margin={"mt-[88px]"}
        />
      </div>

      {/* <div className=" max-w-[90rem] responsive flex items-center justify-center  relative  "> */}
      <div className="max-w-[90rem] responsive relative mx-auto">
        <Swiper
          key={router.locale + "TechSlider"}
          slidesPerView={1}
          spaceBetween={20}
          breakpoints={{
            633: { slidesPerView: 1.3, spaceBetween: 0 },
            949: { slidesPerView: 2.5, spaceBetween: 20 },
            1261: { slidesPerView: 3, spaceBetween: 20 },
            1450: { slidesPerView: 4, spaceBetween: 20 },
          }}
          onSwiper={(swiper) => (next = swiper)}
          onSlideChange={(swiper) =>
            setArrow({ isEnd: swiper.isEnd, isBeginning: swiper.isBeginning })
          }
          modules={[Navigation]}
          navigation={{
            nextEl: ".swiper-button-next-4",
            prevEl: ".swiper-button-prev-4",
          }}
          className="relative h-64 max-w-[90rem] responsive"
        >
          <SwiperSlide
            className={`${
              lang == "ar" ? "border-l-[2px]" : "border-r-[2px]"
            }  border-[#D9D9D9]  max-w-[420px] h-56 flex flex-col justify-between`}
          >
            <div className=" w-full ml-2 flex justify-between  flex-col h-fit">
              <div className="h-[93px] w-[93px] bg-white flex items-center justify-center rounded-full mb-2 shadow-md">
                <Flutter />
              </div>
              <h3 className="text-[24px] font-[600] text-[#6D2E88] mb-3">
                {t("slides.flutter.name")}
              </h3>
              <div className="max-w-[270px]">
                <p className="text-[18px] leading-[26px] font-[400]">
                  {t("slides.flutter.desc")}
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide
            className={`${
              lang == "ar" ? "border-l-[2px]" : "border-r-[2px]"
            } border-[#D9D9D9]  max-w-[420px] h-56 flex flex-col justify-between`}
          >
            <div className=" w-full ml-2 flex justify-between  flex-col h-fit">
              <div className="h-[93px] w-[93px] bg-white flex items-center justify-center rounded-full mb-2 shadow-md">
                <Next />
              </div>
              <h3 className="text-[24px] font-[600] text-[#6D2E88] mb-3">
                {t("slides.nextjs.name")}
              </h3>
              <div className="max-w-[270px]">
                <p className="text-[18px] leading-[26px] font-[400]">
                  {t("slides.nextjs.desc")}
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide
            className={` ${
              lang == "ar" ? "border-l-[2px]" : "border-r-[2px]"
            } border-[#D9D9D9]  max-w-[420px] h-56 flex flex-col justify-between`}
          >
            <div className=" w-full ml-2 flex justify-between  flex-col h-fit">
              <div className="h-[93px] w-[93px] bg-white flex items-center justify-center rounded-full mb-2 shadow-md">
                <Css />
              </div>
              <h3 className="text-[24px] font-[600] text-[#6D2E88] mb-3">
                {t("slides.css.name")}
              </h3>
              <div className="max-w-[270px]">
                <p className="text-[18px] leading-[26px] font-[400]">
                  {t("slides.css.desc")}
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide
            className={`${
              lang == "ar" ? "border-l-[2px]" : "border-r-[2px]"
            } border-[#D9D9D9]  max-w-[420px] h-56 flex flex-col justify-between`}
          >
            <div className=" w-full ml-2 flex justify-between  flex-col h-fit">
              <div className="h-[93px] w-[93px] bg-white flex items-center justify-center rounded-full mb-2 shadow-md">
                <Node />
              </div>
              <h3 className="text-[24px] font-[600] text-[#6D2E88] mb-3">
                {t("slides.node.name")}
              </h3>
              <div className="max-w-[270px]">
                <p className="text-[18px] leading-[26px] font-[400]">
                  {t("slides.node.desc")}
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide
            className={` ${
              lang == "ar" ? "border-l-[2px]" : "border-r-[2px]"
            } border-[#D9D9D9]  max-w-[420px] h-56 flex flex-col justify-between`}
          >
            <div className=" w-full ml-2 flex justify-between  flex-col h-fit">
              <div className="h-[93px] w-[93px] bg-white flex items-center justify-center rounded-full mb-2 shadow-md">
                <Mongo />
              </div>
              <h3 className="text-[24px] font-[600] text-[#6D2E88] mb-3">
                {t("slides.mongo.name")}
              </h3>
              <div className="max-w-[270px]">
                <p className="text-[18px] leading-[26px] font-[400]">
                  {t("slides.mongo.desc")}
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide
            className={` ${
              lang == "ar" ? "border-l-[2px]" : "border-r-[2px]"
            } border-[#D9D9D9]  max-w-[420px] h-56 flex flex-col justify-between`}
          >
            <div className=" w-full ml-2 flex justify-between  flex-col h-fit">
              <div className="h-[93px] w-[93px] bg-white flex items-center justify-center rounded-full mb-2 shadow-md">
                <Postgres />
              </div>
              <h3 className="text-[24px] font-[600] text-[#6D2E88] mb-3">
                {t("slides.postgres.name")}
              </h3>
              <div className="max-w-[270px]">
                <p className="text-[18px] leading-[26px] font-[400]">
                  {t("slides.postgres.desc")}
                </p>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
      <div
        className={`flex justify-center -ml-20 -mr-10 ${
          lang == "ar" ? "-mr-20 -ml-10" : "-ml-20 -mr-10"
        }`}
      >
        <div
          key={lang + "arrows"}
          className={`hidden px-[6%] w-full absolute z-50 top-[65%] lg:flex justify-between right-0`}
        >
          <button
            className={`swiper-button-prev-4 ${
              lang == "ar" ? "-scale-x-100" : null
            }`}
          >
            <PrevArrow arrow={arrow} lang={lang} />
          </button>
          <button
            className={`swiper-button-next-4 ${
              lang == "ar" ? "-scale-x-100" : null
            }`}
          >
            <NextArrow arrow={arrow} lang={lang} />
          </button>
        </div>
      </div>
    </div>
  );
}
